<template>
    <div class="mt-5 row d-flex justify-content-between flex-wrap">
      <!-- 📢 Notice -->
      <v-card class="pa-4 mt-3 ml-5" style="width: 48%; min-height: 300px; border-radius: 10px;">
        <h5 class="font-weight-bold mb-2 ml-5">📢 Notice</h5>
        <v-list dense style="max-height: 50vh; overflow-y: auto;">
          <v-list-item
            v-for="(notice, index) in homeNotices"
            :key="index"
            @click="openNoticePopup(notice)"
            class="hoverable"
            style="cursor: pointer;"
          >
            <v-list-item-content>
              <v-list-item-title class="text-subtitle-2 font-weight-medium mb-1">
                [{{ notice.SDATE }}] {{ notice.TITLE }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption text-grey-darken-1">
                Date: {{ notice.SDATE }} &nbsp;&nbsp; | &nbsp;&nbsp;
                Team: {{ notice.TEAM }} &nbsp;&nbsp; | &nbsp;&nbsp;
                Author: {{ notice.WRITER }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-2" v-if="index !== homeNotices.length - 1" />
        </v-list>
      </v-card>
  <!-- 📅 Calendar -->
        <v-card class="pa-4 mt-3 mr-8 calendar-card" style="width: 48%; min-height: 300px;  border-radius: 10px;">
        <h5 class="font-weight-bold mb-2 ml-3">📅 Calendar</h5>
        <v-date-picker 
            v-model="today"
            color="primary"
            elevation="0"
            show-adjacent-months
            hide-header
            width="100%" 
            class="mt-3"
            
        ></v-date-picker>
        </v-card>


    </div>

  </template>
  
  
<script>
// ✅ 이거 다시 넣기 (HomePage.vue)
import { mapState } from "vuex";
import axios from "axios";

export default {
    name: 'HomePage',
    data() {
        return {
            today: new Date(), // 문자열 대신 Date 객체로 초기화
            noticeDialog: false, // 팝업 표시 여부
            homeNotices: [], // ✅ 공지사항 배열 추가
            selectedNotice: null, // ✅ 추가

        };
    },
    computed: {
        ...mapState({
            username: (state) => state.username, // Vuex에서 username 가져오기
        }),
    },
    mounted() {
      this.fetchNoticeList();
    },
    methods: {
      async fetchNoticeList() {
        try {
          const res = await axios.post("/api/getHomeNoticeList", {
            username: this.username
          });
          //console.log("📢 홈 공지사항 리스트:", res.data);
          this.homeNotices = res.data.notices;
        } catch (err) {
          console.error("❌ 홈 공지사항 호출 실패:", err);
        }
      },
      openNoticePopup(notice) {
        this.selectedNotice = notice;

        const width = 1000;
        const height = 700;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const popup = window.open('', 'noticePopup', `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=no`);

        if (popup) {
          popup.document.write(`
            <html>
            <head>
              <title>📢 Notice</title>
              <style>
                body { font-family: 'Noto Sans KR', sans-serif; padding: 20px; line-height: 1.6; }
                h2 { font-size: 20px; margin-bottom: 16px; font-weight: bold; }
                table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
                td { border: 1px solid #ccc; padding: 8px 12px; vertical-align: top; }
                td:first-child { background-color: #f5f5f5; font-weight: bold; width: 100px; }
                .footer { text-align: right; margin-top: 30px; }
                button { padding: 6px 12px; font-size: 14px; background-color: #007bff; border: none; color: white; cursor: pointer; border-radius: 4px; }
              </style>
            </head>
            <body>
              <h2>📢 Notice</h2>
              <table>
                <tr><td>Title</td><td>${notice.TITLE}</td></tr>
                <tr><td>Date</td><td>${notice.REG_YMD}</td></tr>
                <tr><td>Team</td><td>${notice.TEAM}</td></tr>
                <tr><td>Writer</td><td>${notice.WRITER}</td></tr>
              </table>
              <p>${notice.BODY?.replace(/\n/g, '<br>')}</p>
              <div class="footer">
                <button onclick="window.close()">닫기</button>
              </div>
            </body>
            </html>
          `);
          popup.document.close();
        }
      },

    }


}
</script>
<style scoped>
.custom-font {
    font-family: 'Noto Sans KR' !important;
}

.text-container {
    height: 80vh; /* 화면 높이의 50% 지점에 위치 */
    margin-left: 60vh;
    display: flex;
    justify-content: end; /* 가로 가운데 정렬 */
    align-items: center; /* 세로 가운데 정렬 */
}
.text-container2 {
    height: 1vh; /* 화면 높이의 50% 지점에 위치 */
    margin-left: 60vh;
    display: flex;
    justify-content: end; /* 가로 가운데 정렬 */
    align-items: center; /* 세로 가운데 정렬 */
}

/* 텍스트 스타일 */

@keyframes slideIn {
    from {
        opacity: 0; 
        transform: translateX(-50px); /* 왼쪽에서 시작 */
    }
    to {
        opacity: 1; 
        transform: translateX(0); /* 원래 위치로 */
    }
}

.card-equal {
  width: 19%; /* 딱 5개가 한 줄에 맞게 */
  min-width: 200px;
  margin-right: 1%;
}

@media (max-width: 1200px) {
  .card-equal {
    width: 48%;
    margin-bottom: 20px;
  }
}

@media (max-width: 600px) {
  .card-equal {
    width: 100%;
    margin-bottom: 20px;
  }
}
.chart-card {
  width: 48%;
  min-width: 250px;
  margin-bottom: 20px;
  padding: 16px !important; /* 기본 pa-5에서 줄임 */
  font-size: 0.85rem; /* 전체적으로 폰트 축소 */
}

.chart-card h5 {
  font-size: 1rem;
  margin-bottom: 12px;
}

.chart-card canvas {
  max-height: 230px; /* 그래프 크기도 약간 줄임 */
}

/* 반응형 대응 */
@media (max-width: 992px) {
  .chart-card {
    width: 100%;
  }
}

.container-fluid {
  height : 95%;
  overflow-y: auto;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

.v-picker_body {
  border: 2px solid black; /* 검은 테두리 */
  border-radius: 8px;
  overflow: hidden; /* border 넘치는 부분 정리 */
}



/* 선택된 날짜도 줄이 사라지지 않게 */
::v-deep(.v-date-picker-month__day--active) {
  border: 1px solid #000;
}
.hoverable:hover {
  background-color: #f2f2f2;
}
</style>